import FILTERS from '../../models/filters.js';

class TableGridTextCellController {
  constructor() {
    this.name = 'tableGridTextCell';
    this.filters = FILTERS;
  }

  getCellValue(row, column) {
    var cellValue = row[column.name];

    if (column.virtualAttribute) {
      cellValue = column.virtualAttribute(row);
    }

    if (column.formatFilter && cellValue) {
      cellValue = this.processFilter(cellValue, column.formatFilter);
    }

    return cellValue;
  }

  processFilter(cellValue, filter){
    return this.filters[filter](cellValue);
  }
}

export
default TableGridTextCellController;



// WEBPACK FOOTER //
// ./app/components/tableGridTextCell/tableGridTextCell.controller.js